/**
 * Motion Configuration for SuperKonnected
 * 
 * Centralized motion values for consistent, calm animations throughout the app.
 * Design principles:
 * - Calm & focused
 * - No visual noise
 * - Motion supports hierarchy, not attention-seeking
 * - Respects prefers-reduced-motion
 */

// Opacity levels for navigation hierarchy
export const opacity = {
  inactive: 0.1,
  hover: 0.5,
  active: 1,
} as const;

// Durations in seconds
export const duration = {
  navigation: 0.18,
  card: 0.18,
  fast: 0.15,
} as const;

// Easing curves
export const easing = {
  out: [0.25, 0.1, 0.25, 1.0],
} as const;

// Card hover transforms
export const cardHover = {
  y: -2, // Max 2px movement
  opacityBoost: 0.05,
  shadowIntensity: 1.1,
} as const;

// Check for reduced motion preference
export const shouldReduceMotion = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

// Motion variants for navigation items
export const navItemVariants = {
  inactive: {
    opacity: opacity.inactive,
    transition: {
      duration: duration.navigation,
      ease: easing.out,
    },
  },
  hover: {
    opacity: opacity.hover,
    transition: {
      duration: duration.navigation,
      ease: easing.out,
    },
  },
  active: {
    opacity: opacity.active,
    transition: {
      duration: duration.navigation,
      ease: easing.out,
    },
  },
} as const;

// Motion variants for cards
export const cardVariants = {
  initial: {
    y: 0,
  },
  hover: {
    y: cardHover.y,
    transition: {
      duration: duration.card,
      ease: easing.out,
    },
  },
} as const;
